import ScreensViewContainer from './containers/ScreensViewContainer';

export default ScreensViewContainer;